import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const menuItems = [
  { to: '/patient/dashboard', icon: 'ri-dashboard-line', label: 'Dashboard' },
  { to: '/patient/dashboard/appointments', icon: 'ri-calendar-line', label: 'Appointments' },
  { to: '/patient/dashboard/profile', icon: 'ri-user-3-line', label: 'Profile' },
  { to: '/patient/dashboard/ehr', icon: 'ri-folder-3-line', label: 'EHR' },
  { to: '/patient/dashboard/billing', icon: 'ri-bank-card-line', label: 'Billing' },
  { to: '/patient/dashboard/collaborations', icon: 'ri-team-line', label: 'Collaborations' },
  { to: '/patient/dashboard/clinics', icon: 'ri-hospital-line', label: 'Clinics' },
  { to: '/patient/dashboard/medication', icon: 'ri-capsule-line', label: 'Medication' },
  { to: '/patient/dashboard/treatments', icon: 'ri-stethoscope-line', label: 'Treatments' },
  { to: '/patient/dashboard/resources', icon: 'ri-book-open-line', label: 'Resources' },
  { to: '/patient/dashboard/healthtracker', icon: 'ri-heart-pulse-line', label: 'Health Tracker' },
];

const PatientDashboardSideMenu: React.FC = () => {
  const location = useLocation();
  return (
    <nav className="flex flex-col h-full justify-between rounded-none pt-0">
      <div>
        <div className="flex items-center justify-center mb-8 mt-0">
          <div className="flex items-center">
            <div className="bg-blue-600 rounded-full flex items-center justify-center mr-2" style={{ width: 48, height: 48 }}>
              <span className="text-white font-bold text-lg">U</span>
            </div>
            <span className="text-xl font-bold text-blue-700 tracking-tight">UZIMA</span>
          </div>
        </div>
        <ul className="space-y-2">
          {menuItems.map((item) => (
            <li key={item.to}>
              <Link
                to={item.to}
                className={`flex items-center gap-3 w-full px-4 py-2 rounded-none transition-colors duration-200 text-lg font-medium
                  ${location.pathname.startsWith(item.to)
                    ? 'bg-blue-100 text-blue-600 shadow'
                    : 'text-gray-500 hover:bg-gray-100 hover:text-blue-500'}
                `}
                title={item.label}
              >
                <i className={`${item.icon} text-2xl`}></i>
                <span>{item.label}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div className="mb-4 flex flex-col items-center">
        <button className="w-full flex items-center gap-3 px-4 py-2 rounded-none text-red-400 hover:bg-red-50 hover:text-red-600 transition-colors text-lg font-medium" title="Log Out">
          <i className="ri-logout-box-r-line text-2xl"></i>
          <span>Log Out</span>
        </button>
      </div>
    </nav>
  );
};

export default PatientDashboardSideMenu;